import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Selector from './Selector'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
`

export const SelectButton = styled(Button)`
  margin-top: 15px;
`

export const SizeButton = styled(Button)`
  margin-top: 15px;
`

export const ConfirmButton = styled(Button)`
  margin-top: 60px;
`

export const Content = styled.div`
  text-align: center;
`

export const SelectedChoice = styled.div`
  font-size: 28px;
  color: ${colors.darkPurple};
  margin: 10px 0 25px 0;
`

const PLANS = [
  { nbStudents: '1-14', title: 'Small' },
  { nbStudents: '15-35', title: 'Medium' },
  { nbStudents: '35+', title: 'Large' }
]

export default class ClassSizePopup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selecting: false,
      selected: false
    }
    let products = props.products.slice().sort((x, y) => x.metadata.maxUsers - y.metadata.maxUsers)
    this.products = products.map((p, i) => {
      let nbStudents
      if (i === 0) {
        nbStudents = `1-${p.metadata.maxUsers}`
      } else {
        nbStudents = `${products[i - 1].metadata.maxUsers + 1}-${p.metadata.maxUsers}`
      }
      return {
        product: p,
        nbStudents,
        title: p.name
      }
    })
  }

  selectClassSize (o) {
    this.setState({
      selected: true,
      selecting: false,
      choice: o
    })
  }

  onSelectAction () {
    this.setState({
      selecting: true
    })
  }

  renderNotSelectedView () {
    return [
      <div key='1'>
        <SelectButton block={false} onClick={this.onSelectAction.bind(this)}>
          Select
        </SelectButton>
      </div>,
      <div key='2'>
        <ConfirmButton disabled>Confirm</ConfirmButton>
      </div>
    ]
  }

  renderSelectingContent () {
    return (
      <Selector
        options={this.products.map(p => ({
          product: p.product,
          label: `${p.nbStudents} students`,
          info: p.title
        }))}
        onSelect={this.selectClassSize.bind(this)}
      />
    )
  }

  renderSelectedContent () {
    const { choice } = this.state
    return [
      <SizeButton key='1' onClick={this.onSelectAction.bind(this)}>
        {choice.info}
      </SizeButton>,
      <SelectedChoice key='2'>{choice.label}</SelectedChoice>,
      <Button key='3' bgColor={colors.success} onClick={() => this.props.onSubmit(this.state.choice.product)}>Confirm</Button>
    ]
  }

  render () {
    return (
      <DashboardPopup onCancel={this.props.onCancel}>
        <Title>What size is your class?</Title>
        <Content>
          {!this.state.selecting &&
            !this.state.selected &&
            this.renderNotSelectedView()}
          {this.state.selecting && this.renderSelectingContent()}
          {!this.state.selecting &&
            this.state.selected &&
            this.renderSelectedContent()}
        </Content>
      </DashboardPopup>
    )
  }
}
